/**
 * DescriptionFacts channel name (bold) on the facts line.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const DescriptionFactsChannelText = styled.span`
  color: ${Colors['text']};
  float: left;
  font-family: ${Fonts['bold']};
  font-size: ${32 * Screen.widthRatio}px;
  line-height: ${40 * Screen.widthRatio}px;
  margin-right: ${8 * Screen.widthRatio}px;
`;

export default DescriptionFactsChannelText;
